import React from "react";
import Skeleton from "@mui/material/Skeleton";
import MDBox from "components/MDBox";

export default function SuggestionsLoader() {
  return (
    <MDBox>
      <MDBox
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "0.5rem",
          marginBottom: "1rem",
        }}
      >
        <Skeleton
          sx={{
            bgcolor: "grey.900",
            height: 40,
            width: 40,
          }}
          variant="circular"
        />

        <Skeleton
          sx={{
            bgcolor: "grey.900",
            height: 30,
            width: 150,
          }}
          variant="text"
        />
      </MDBox>

      <MDBox
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "0.5rem",
          marginBottom: "1rem",
        }}
      >
        <Skeleton
          sx={{
            bgcolor: "grey.900",
            height: 40,
            width: 40,
          }}
          variant="circular"
        />

        <Skeleton
          sx={{
            bgcolor: "grey.900",
            height: 30,
            width: 150,
          }}
          variant="text"
        />
      </MDBox>

      <MDBox
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "0.5rem",
          marginBottom: "1rem",
        }}
      >
        <Skeleton
          sx={{
            bgcolor: "grey.900",
            height: 40,
            width: 40,
          }}
          variant="circular"
        />

        <Skeleton
          sx={{
            bgcolor: "grey.900",
            height: 30,
            width: 150,
          }}
          variant="text"
        />
      </MDBox>

      <MDBox
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "0.5rem",
          marginBottom: "1rem",
        }}
      >
        <Skeleton
          sx={{
            bgcolor: "grey.900",
            height: 40,
            width: 40,
          }}
          variant="circular"
        />

        <Skeleton
          sx={{
            bgcolor: "grey.900",
            height: 30,
            width: 150,
          }}
          variant="text"
        />
      </MDBox>

      <MDBox
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "0.5rem",
          marginBottom: "1rem",
        }}
      >
        <Skeleton
          sx={{
            bgcolor: "grey.900",
            height: 40,
            width: 40,
          }}
          variant="circular"
        />

        <Skeleton
          sx={{
            bgcolor: "grey.900",
            height: 30,
            width: 150,
          }}
          variant="text"
        />
      </MDBox>
    </MDBox>
  );
}
